import { useRef } from "react";
import { NSBox, NSBoxEntity, NSBoxPhone, NSBoxTextArea, NSButtonBlue, NSColumn, NSPanel, NSRow, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { ProviderRow } from "namirasoft-sms-sender";
import { SMSSenderEntities } from "../SMSSenderEntities";
import { SMSSenderProps } from "../SMSSenderProps";
import { SMSSenderRoutes } from "../SMSSenderRoutes";
import { SMSSenderLayout } from "../SMSSenderLayout";
import { useParams } from "react-router-dom";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

interface SendPageProps extends NSARouterMakerResult, SMSSenderProps
{
}

export default function SendPage(props: SendPageProps)
{
	let NSBoxPhone_Phone = useRef<NSBoxPhone>(null);
	let NSBoxTexArea_Message = useRef<NSBoxTextArea>(null);
	let NSBoxEntity_Provider = useRef<NSBoxEntity<ProviderRow>>(null);

	let { id } = useParams();

	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<SMSSenderLayout
			{...props}
			action={{
				title: "Send",
				description: "Enter the destination phone number and your message to send an SMS via the selected provider.",
				menus: {}
			}}
			pages={{
				entity: SMSSenderEntities.provider(props),
			}}
		>
			<NSPanel>
				<NSColumn style={{ width: NSBox.width.double }}>
					<NSRow>
						<NSBoxEntity
							ref={NSBoxEntity_Provider}
							title="Provider"
							required
							multiple={false}
							table={namirasoft.sms_sender.tables.provider}
							getValue={item => item.id}
							getTitle={item => item.name}
							getSort={() => null}
							onLoaded={() =>
							{
								if (id)
									NSBoxEntity_Provider.current?.setValue(id);
							}}
                            info={{ link: "https://namirasoft.com/sms-sender/console-guide/send/#field-provider-id" }}
						/>
						<NSBoxPhone
							title="Phone"
							required
							ref={NSBoxPhone_Phone}
                            info={{ link: "https://namirasoft.com/sms-sender/console-guide/send/#field-phone" }}
						/>
					</NSRow>
					<NSBoxTextArea
						title="Message"
						required
						ref={NSBoxTexArea_Message}
						placeholder="Write your Message"
						style={{ width: "100%" }}
                        info={{ link: "https://namirasoft.com/sms-sender/console-guide/send/#field-message" }}
					/>
					<NSSpace size={NSSpaceSizeType.MINI}
					></NSSpace>
					<NSRow>
						<NSButtonBlue title="Apply"
							onClick={{
								action: (onFinished) =>
								{
									try
									{
										let provider_id = NSBoxEntity_Provider.current?.getValueOne();
										if (provider_id)
										{
											let phone = NSBoxPhone_Phone.current?.getValue() ?? "";
											let message = NSBoxTexArea_Message.current?.getValue() ?? "";
											props.servers.sms_sender.sms.Send({ provider_id: provider_id, phone, message }).then((res) =>
											{
												props.notifier.onSuccess("An SMS was sent successfully");

												let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);
												let filters = [new FilterItem(namirasoft.sms_sender.tables.sent, namirasoft.sms_sender.tables.sent.columns.id, false, FilterItemOperator.all.equals, res.id)];
												props.url.redirect(SMSSenderRoutes.SentList, { filters: FilterItem.encode(filters) });
												onFinished();
											}).catch(onFinished);
										}

									} catch (error)
									{
										props.notifier.onError(error as Error);
									}
									onFinished();
								}
							}}
						/>
					</NSRow>
				</NSColumn>
			</NSPanel>
		</SMSSenderLayout>
	);
}